import { useQuery } from '@tanstack/react-query';
import { fetchOrders } from './request';
import { ORDERS_QUERY_KEY } from './key';

export const useOrders = ({
  page,
  pageSize,
}: {
  page?: number;
  pageSize?: number;
} = {}) => {
  return useQuery({
    queryKey: [ORDERS_QUERY_KEY, page, pageSize],
    queryFn: () => fetchOrders({ page, pageSize }),
  });
};
